// Homepage hero photos. One is picked at random per page load so repeat
// visitors see different work. Every entry must show actual tree work —
// scenery-only shots were deliberately left out, they don't sell the service.
// The first three are One Choice's own job photos; the last two are Pexels
// (free for commercial use) and are already used elsewhere on the site.
const heroImages = [
  {
    src: 'https://flappy-bird.nyc3.cdn.digitaloceanspaces.com/ONE/6794577484929289205.jpg',
    alt: 'One Choice crew member cutting a large tree beside a Maryland home'
  },
  {
    src: 'https://flappy-bird.nyc3.cdn.digitaloceanspaces.com/ONE/5584559015441101802.jpg',
    alt: 'One Choice climber working a tall tree from a lift'
  },
  {
    src: 'https://flappy-bird.nyc3.cdn.digitaloceanspaces.com/ONE/2893782948520664233.jpg',
    alt: 'Hazardous tree being sectioned and removed'
  },
  {
    src: 'https://images.pexels.com/photos/6218318/pexels-photo-6218318.jpeg?auto=compress&cs=tinysrgb&w=800',
    alt: 'Arborist roping down a cut log from a tree'
  },
  {
    src: 'https://images.pexels.com/photos/31127615/pexels-photo-31127615/free-photo-of-arborist-cutting-down-tree-trunk-safely-with-chainsaw.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
    alt: 'Arborist cutting a tree trunk with a chainsaw'
  }
];

export const pickHeroImage = () =>
  heroImages[Math.floor(Math.random() * heroImages.length)];

export default heroImages;
